const BUILDINGS = {
  "net_zero_futures_dvl_shift_high_0909": {
    "2025": { "electricity": 178.9, "hydrogen": 0, "fossil": 488.36, "biofuels": 2.83, "other": 20.09 },
    "2030": { "electricity": 170.05, "hydrogen": 0, "fossil": 446.78, "biofuels": 4.14, "other": 33.17 },
    "2035": { "electricity": 194.87, "hydrogen": 0, "fossil": 373.15, "biofuels": 2.47, "other": 49.29 },
    "2040": { "electricity": 219.98, "hydrogen": 0, "fossil": 277.87, "biofuels": 0.26, "other": 68.81 },
    "2045": { "electricity": 240.37, "hydrogen": 26.97, "fossil": 159.27, "biofuels": 0.07, "other": 102.18 },
    "2050": { "electricity": 277.26, "hydrogen": 73.09, "fossil": 0, "biofuels": 19.58, "other": 117.7 }
  },
  "net_zero_futures_dvl_shift_low_0909": {
    "2025": { "electricity": 178.9, "hydrogen": 0, "fossil": 488.36, "biofuels": 2.83, "other": 20.09 },
    "2030": { "electricity": 171.96, "hydrogen": 0, "fossil": 441.51, "biofuels": 4.56, "other": 33.23 },
    "2035": { "electricity": 198.75, "hydrogen": 0, "fossil": 358.2, "biofuels": 7.46, "other": 49.35 },
    "2040": { "electricity": 222.71, "hydrogen": 0.15, "fossil": 280.89, "biofuels": 5.21, "other": 68.82 },
    "2045": { "electricity": 245.44, "hydrogen": 29.95, "fossil": 165.39, "biofuels": 2.54, "other": 99.68 },
    "2050": { "electricity": 301.56, "hydrogen": 85.03, "fossil": 1.67, "biofuels": 18.23, "other": 111.52 }
  },
  "net_zero_futures_dvl_steer_high_0909": {
    "2025": { "electricity": 178.93, "hydrogen": 0, "fossil": 488.36, "biofuels": 2.83, "other": 20.09 },
    "2030": { "electricity": 179.78, "hydrogen": 0, "fossil": 432.09, "biofuels": 3.65, "other": 34.27 },
    "2035": { "electricity": 215.88, "hydrogen": 17.87, "fossil": 315.22, "biofuels": 8.26, "other": 54.12 },
    "2040": { "electricity": 233.06, "hydrogen": 17.87, "fossil": 241.82, "biofuels": 0, "other": 71.59 },
    "2045": { "electricity": 259.43, "hydrogen": 17.87, "fossil": 146.55, "biofuels": 0, "other": 84.21 },
    "2050": { "electricity": 291.32, "hydrogen": 17.87, "fossil": 69.27, "biofuels": 10.48, "other": 86.49 }
  },
  "net_zero_futures_dvl_steer_low_0909": {
    "2025": { "electricity": 178.93, "hydrogen": 0, "fossil": 488.36, "biofuels": 2.83, "other": 20.09 },
    "2030": { "electricity": 179.36, "hydrogen": 0, "fossil": 435.51, "biofuels": 2.89, "other": 34.69 },
    "2035": { "electricity": 223.26, "hydrogen": 25.98, "fossil": 307.47, "biofuels": 7.38, "other": 54.49 },
    "2040": { "electricity": 234.83, "hydrogen": 19.2, "fossil": 253.18, "biofuels": 0.81, "other": 72.87 },
    "2045": { "electricity": 263.25, "hydrogen": 25.98, "fossil": 162.4, "biofuels": 0.39, "other": 85.28 },
    "2050": { "electricity": 292.98, "hydrogen": 11.98, "fossil": 92.66, "biofuels": 6.41, "other": 100.48 }
  },
  "net_zero_futures_dvl_transform_high_0909": {
    "2025": { "electricity": 178.9, "hydrogen": 0, "fossil": 488.36, "biofuels": 2.83, "other": 20.09 },
    "2030": { "electricity": 153.77, "hydrogen": 0.48, "fossil": 434.3, "biofuels": 3.7, "other": 23.04 },
    "2035": { "electricity": 203.5, "hydrogen": 14.43, "fossil": 299.78, "biofuels": 9.02, "other": 23.94 },
    "2040": { "electricity": 238.74, "hydrogen": 21.59, "fossil": 190.76, "biofuels": 6.73, "other": 23.3 },
    "2045": { "electricity": 258.84, "hydrogen": 37.33, "fossil": 90.64, "biofuels": 7.27, "other": 23.44 },
    "2050": { "electricity": 259.85, "hydrogen": 48.05, "fossil": 0, "biofuels": 20.53, "other": 32.17 }
  },
  "net_zero_futures_dvl_transform_low_0909": {
    "2025": { "electricity": 178.9, "hydrogen": 0, "fossil": 488.36, "biofuels": 2.83, "other": 20.09 },
    "2030": { "electricity": 155.22, "hydrogen": 0.38, "fossil": 437.35, "biofuels": 3.87, "other": 23.04 },
    "2035": { "electricity": 206, "hydrogen": 12.26, "fossil": 308.26, "biofuels": 8.21, "other": 24.13 },
    "2040": { "electricity": 244.97, "hydrogen": 18.17, "fossil": 208.24, "biofuels": 5.69, "other": 23.43 },
    "2045": { "electricity": 267.78, "hydrogen": 42.26, "fossil": 104.42, "biofuels": 4.6, "other": 23.35 },
    "2050": { "electricity": 276.02, "hydrogen": 74.18, "fossil": 0, "biofuels": 19.05, "other": 32.16 }
  },
  net_zero_futures_dvl_shift_high_transstshiftec_2001: {
    2025: { electricity: 178.90,    hydrogen: 0,    fossil: 488.36, biofuels: 2.83, other: 20.09 },
    2030: { electricity: 169.85, hydrogen: 0,    fossil: 446.51, biofuels: 4.47,  other: 33.17 },
    2035: { electricity: 194.88, hydrogen: 0,  fossil: 372.24,  biofuels: 3.44, other: 49.30 },
    2040: { electricity: 220.36, hydrogen: 0, fossil: 276.27, biofuels: 0.81, other: 68.82 },
    2045: { electricity: 243.35, hydrogen: 27.27,    fossil: 148.07,  biofuels: 3.02, other: 99.99 },
    2050: { electricity: 277.19, hydrogen: 74.25, fossil: 0,     biofuels: 22.58, other: 114.17 },
  },
};

export default BUILDINGS;
